import { render } from "./Tenders.vue?vue&type=template&id=34426f2a"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"
script.render = render

export default script